const userTextMessage = (background_color, accent_color, text) => {
  return `<li class="self" style="background:${background_color};color:${accent_color}">${text}</li>`;
};

export default userTextMessage;
